angular.module('unica_campaign.campaign_controllers')

.controller('CampaignCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	CampaignCreateService
) {
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.resetCampaignData();

	$scope.getCampaignTemplateList();

	$scope.saveCampaign = function()
	{
		$scope.showLoader();

		CampaignCreateService
			.create( $scope.event_id, $scope.campaignData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Campagna creata con successo!', '');

					$state.go('app.campaign.assign', { event_id: $stateParams.event_id, id: data.id });
				}
			});
	};

});


